import app from '../../forum/app';
import Page, { IPageAttrs } from '../../common/components/Page';
import DiscussionComposer from './DiscussionComposer';
import ComposerPostPreview from "./ComposerPostPreview";


export default class PostNewDiscussion extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    this.bodyClass = 'App--newDiscussion';

    if (!app.composer.bodyMatches(DiscussionComposer)) {
      app.composer.load(DiscussionComposer, {user: app.session.user});
    }
  }

  oncreate(vnode) {
    super.oncreate(vnode);

    if (app.composer.bodyMatches(DiscussionComposer) && !app.composer.isVisible()) {
      setTimeout(() => {
        app.composer.show();
      }, 0);
    }
  }

  onremove(vnode) {
    super.onremove(vnode);

    if (app.composer.bodyMatches(DiscussionComposer) && app.composer.isVisible()) {
      app.composer.hide();
    }
  }

  view() {
    return (
      <div className="PostNewDiscussionPage container">
        <div></div>
        {this.isEditing()
          ? <ComposerPostPreview className="Post-preview" composer={app.composer} surround={this.anchorPreview.bind(this)} />
          : ''
        }
      </div>
    );
  }

  anchorPreview(preview) {
    const anchorToBottom = $(window).scrollTop() + $(window).height() >= $(document).height();

    preview();

    if (anchorToBottom) {
      $(window).scrollTop($(document).height());
    }
  }

  isEditing() {
    return app.composer.bodyMatches(DiscussionComposer, { user: app.session.user });
  }
}
